import React, { useEffect, useMemo } from 'react'
import { useRecoilState } from 'recoil'
import styled from '@emotion/styled'
import { Shapes } from 'src/components/theme'
import { MapStyle } from 'src/types/map'

import { StyleToggle } from 'src/components/map/mapbox/controls/style-toggle'
import { AerialBanner, AerialToggle } from 'src/components/map/google-map/aerial-toggle'

import * as mainMapAtoms from 'src/atoms/main-map'

const PositionWrapper = styled.div`
  position: absolute;
  bottom: ${Shapes.spacing[2]}px;
  right: ${Shapes.spacing[8]}px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${Shapes.spacing[2]}px;
`

export const AERIAL_TOGGLE_ZOOM_THRESHOLD = 16

type Props = {
  zoom?: number
  mapStyle: MapStyle
  setMapStyle: React.Dispatch<React.SetStateAction<MapStyle>>
}
export const MapTypeToggle: React.FC<Props> = ({ zoom, mapStyle, setMapStyle }) => {
  const [isAerialEnabled, setAerialEnabled] = useRecoilState(mainMapAtoms.isAerialEnabled)
  const showAerial = useMemo(
    () => (mapStyle === MapStyle.SATELLITE && zoom && zoom >= 16) || isAerialEnabled,
    [mapStyle, zoom]
  )

  // Reset aerial toggle when we switch to a non-satellite map/zoom out
  useEffect(() => {
    const showableAerial = mapStyle === MapStyle.SATELLITE && zoom && zoom >= AERIAL_TOGGLE_ZOOM_THRESHOLD
    if (!showableAerial && isAerialEnabled) {
      setAerialEnabled(false)
    }
  }, [isAerialEnabled, mapStyle, zoom])

  return (
    <>
      {isAerialEnabled && <AerialBanner />}
      <PositionWrapper>
        {showAerial && (
          <AerialToggle
            style={{
              marginRight: `-${Shapes.spacing[7]}px`,
            }}
          />
        )}
        <StyleToggle mapStyle={mapStyle} onMapStyleChange={setMapStyle} />
      </PositionWrapper>
    </>
  )
}
